"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BcDefaultBehavior = exports.ELEMENT_IS_INVALID = exports.ID_NOT_FOUND = exports.METHOD_NOT_IMPLEMENTED = void 0;
var common_constants_1 = require("../../common/constants/common-constants");
exports.METHOD_NOT_IMPLEMENTED = 'Method not implemented.';
exports.ID_NOT_FOUND = 'The given id is not present in the DOM';
exports.ELEMENT_IS_INVALID = 'The element inside in object is not valid.';
var BcDefaultBehavior = (function () {
    function BcDefaultBehavior() {
        this.disabled = false;
        this.isReady = false;
    }
    BcDefaultBehavior.prototype._setUp = function () {
        if (this.mySelf === undefined || this.mySelf === null) {
            throw new Error(exports.ELEMENT_IS_INVALID);
        }
    };
    BcDefaultBehavior.prototype.setId = function (id) {
        this._id = id;
        this.mySelf = document.getElementById(this._id);
        if (this.mySelf === null) {
            throw new Error(exports.ID_NOT_FOUND);
        }
        this.setPlaceHolder();
        return this.mySelf;
    };
    BcDefaultBehavior.prototype.setElement = function (element) {
        this.mySelf = element;
        this.setPlaceHolder();
    };
    BcDefaultBehavior.prototype.getMySelf = function () {
        return this.mySelf;
    };
    BcDefaultBehavior.prototype.setUp = function (force) {
        if (force === void 0) { force = false; }
        if (!this.isReady || force) {
            try {
                this._setUp();
                this.isReady = true;
            }
            catch (error) {
                this.isReady = false;
            }
        }
    };
    BcDefaultBehavior.prototype.setDisable = function (status) {
        if (status) {
            this.mySelf.classList.add(common_constants_1.BcCommonConstants.DISABLE_CLASS);
        }
        else {
            this.mySelf.classList.remove(common_constants_1.BcCommonConstants.DISABLE_CLASS);
        }
    };
    BcDefaultBehavior.prototype.setPlaceHolder = function () {
        var el = this.mySelf;
        var placeHolder = el === null || el === void 0 ? void 0 : el.placeholder;
        if (!placeHolder) {
            el.placeholder = " ";
        }
    };
    return BcDefaultBehavior;
}());
exports.BcDefaultBehavior = BcDefaultBehavior;
